import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class DocumentPaymentListItem {
  @IsNumber()
  @Expose()
  id!: number; //618483,
  @IsString()
  @Expose()
  createDate!: string; // "05.02.2021",
  @IsNumber()
  @Expose()
  amount!: number; //1369.35,
  @IsNumber()
  @Expose()
  amountInCurrency!: number; //1369.35,
  @IsNumber()
  @Expose()
  amountInDocumentCurrency!: number; //1369.35,
  @IsString()
  @Expose()
  formOfPaymentName!: string; // "PayPal",
  @IsNumber()
  @Expose()
  formOfPaymentId!: number; // 17,
  @IsString()
  @Expose()
  exchangeDate!: string; //"2021-02-04T00:00:00",
  @IsString()
  @Expose()
  paymentDate!: string; // "05.02.2021",
  @IsOptional()
  @IsString()
  @Expose()
  description!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  documentNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  linkDocumentNumbers!: string | null;
  @IsString()
  @Expose()
  currency!: string; // "PLN",
  @IsString()
  @Expose()
  documentId!: string; // "1c07337f-5abd-4313-9360-4b8566615e71",
  @IsNumber()
  @Expose()
  cashboxId!: number; // 1,
  @IsNumber()
  @Expose()
  recordStampId!: number; // 0
}

export type DocumentPaymentsList = Array<DocumentPaymentListItem>;
